import { SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetFooter,
} from "@/components/ui/sheet";

export function MobileFilterButton({
  label,
  count = 0,
  onClick,
}: {
  label: string;
  count?: number;
  onClick: () => void;
}) {
  return (
    <Button
      variant="ghost"
      size="icon"
      className="relative rounded-lg"
      data-mobile-filter
      aria-label={label}
      onClick={onClick}
    >
      <SlidersHorizontal className="size-5" />
      {count > 0 && (
        <span className="absolute -right-1 -top-1 flex size-4 items-center justify-center rounded-full bg-primary text-[10px] text-primary-foreground">
          {count}
        </span>
      )}
    </Button>
  );
}

export function MobileFilterPanel({
  open,
  onOpenChange,
  title,
  children,
  onReset,
  onApply,
  applyLabel = "Готово",
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
  onReset: () => void;
  onApply?: () => void;
  applyLabel?: string;
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        className="flex max-h-[85dvh] flex-col rounded-t-2xl gap-0 p-0"
      >
        <SheetHeader className="border-b p-4 pr-12">
          <SheetTitle>{title}</SheetTitle>
        </SheetHeader>
        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain p-4 space-y-4">
          {children}
        </div>
        <SheetFooter className="grid shrink-0 grid-cols-2 gap-3 border-t bg-card p-4 pb-[calc(1rem+env(safe-area-inset-bottom))]">
          <Button variant="outline" onClick={onReset}>
            Сбросить
          </Button>
          <Button onClick={onApply ?? (() => onOpenChange(false))}>
            {applyLabel}
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
